import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import CalendarEventDetail from './CalendarEventDetail';

loadDOMComponent({
	selector: 'react-calendar-event-detail',
	callback: ({ container, context }: any) => {
		const eventId = container.getAttribute('eventId');
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CalendarEventDetail eventId={eventId} patientId={patientId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
